import React from 'react'
import type { PivotLayout } from '@ztechapps/common.contract'
import { PivotGrandTotalsEnum } from '@ztechapps/common.contract'
import { BusyButton } from '@ztechapps/webui.button'
import { Field, FormModal } from '@ztechapps/webui.form'
import { RadioInputGroup } from '@ztechapps/webui.input'
import { usePivotViewerContext } from './Context'

const GRAND_TOTALS_OPTIONS = [
  { label: 'Do not show', value: PivotGrandTotalsEnum.Off },
  { label: 'Show', value: PivotGrandTotalsEnum.On },
  { label: 'Rows only', value: PivotGrandTotalsEnum.Rows },
  { label: 'Columns only', value: PivotGrandTotalsEnum.Columns },
]

const SUBTOTALS_OPTIONS = [
  { label: 'Do not show', value: PivotGrandTotalsEnum.Off },
  { label: 'Show', value: PivotGrandTotalsEnum.On },
]

/** Props for the pivot options dialog. */
export type PivotOptionsModalProps = {
  showSubtotals: boolean
  showGrandTotals: PivotGrandTotalsEnum
  onApply: (options: Pick<PivotLayout, 'showSubtotals' | 'showGrandTotals'>) => void
}

/** Dialog staging the pivot totals options until applied. */
export const PivotOptionsModal = ({ showSubtotals, showGrandTotals, onApply }: PivotOptionsModalProps) => {
  const { container } = usePivotViewerContext()

  return (
    <FormModal<{ showGrandTotals: PivotGrandTotalsEnum; showSubtotals: PivotGrandTotalsEnum }>
      trigger={({ onClick }) => <BusyButton icon="sliders" text="Options" onClick={onClick} />}
      title="Options"
      saveText="Apply"
      resizable
      resizeStorageKey="pivot-options"
      container={container}
      initialValues={{
        showGrandTotals,
        showSubtotals: showSubtotals ? PivotGrandTotalsEnum.On : PivotGrandTotalsEnum.Off,
      }}
      onSubmit={(values) =>
        onApply({
          showGrandTotals: values.showGrandTotals,
          showSubtotals: values.showSubtotals === PivotGrandTotalsEnum.On,
        })
      }
    >
      <Field name="showGrandTotals" label="Grand totals" component={RadioInputGroup} options={GRAND_TOTALS_OPTIONS} />
      <Field name="showSubtotals" label="Subtotals" component={RadioInputGroup} options={SUBTOTALS_OPTIONS} />
    </FormModal>
  )
}
